import {Component, Input, isDevMode, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild} from '@angular/core';
import {Observable, of, Subject} from "rxjs";
import {takeUntil} from "rxjs/operators";
import {Centre} from "../../../../interfaces/Centres";
import {MatPaginator} from "@angular/material/paginator";
import {FullChild} from "../../../../interfaces/FullChild";
import {CentreService} from "../../../../services/centre.service";
import {AngularFirestore, AngularFirestoreCollection} from "@angular/fire/compat/firestore";
import {ChildService} from "../../../../components/child/child.service";
import {MatSort} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {EducationService} from "../../../education/education.service";
import {environment} from "../../../../../environments/environment";
import firebase from "firebase/compat";
import {MatSelectChange} from "@angular/material/select";
import {AngularFireDatabase} from "@angular/fire/compat/database";
import {MatSnackBar} from "@angular/material/snack-bar";
import {LogService} from "../../../../services/log.service";
import * as XLSX from "xlsx";
import {FinancialYearService} from "../../../../services/financial-year.service";
import {endOfDay} from '../../../../utils/date-range-format.service';

@Component({
  selector: 'app-attendance-report',
  templateUrl: './attendance-report.component.html',
  styleUrls: ['./attendance-report.component.scss']
})
export class AttendanceReportComponent implements OnInit, OnChanges, OnDestroy {
  private _destroyed$ = new Subject<void>();
  // External inputs from parent (education-presentation)
  @Input() hideFilters: boolean = false;
  @Input() hideTable: boolean = false;
  @Input() externalStartDate: Date | null = null;
  @Input() externalEndDate: Date | null = null;
  @Input() externalCentre: string | string[] = '';
  @Input() triggerSearch: number = 0;
  /** Normalised list of selected centre codes; empty = all centres */
  selectedCentreCodes: string[] = [];
  selectedGender: string |null= '';
  centres$: Observable<Centre[]>;
  childBycentre: Observable<FullChild[]> | undefined;
  startDate: Date | undefined | null = null;
  endDate: Date | undefined | null = null
  selectedCentre:string|null='';
  sessionType :string|null= ''
  // dataSource: any;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  dataSource: MatTableDataSource<any>
  displayedColumns: string[] = ['centre', 'childName', 'gender', 'sessionType', 'subject', 'presentAbsent'];
  @ViewChild(MatSort, { static: true }) sort!: MatSort;
  selectedSubject: any;
  selectedAttendace: any;
  educationData: any[]=[];
  mAllData: any[] = [];
  env = isDevMode() ? environment.testMode : environment.productionMode
  baseRef: AngularFirestoreCollection<any>
  genderLables: string[]=["Male","Female"];
  subjectLables: string[]=["Language","Maths","EVS/GK"];
  sessionLables: string[]=["Rapport Building","Baseline Assessment","Regular Study","Intermediate Assessment",'Discharge Assessment'];
  shortLables: string[]=["Rapport Building","Baseline Assessment","Regular Study","Intermediate Assessment",'Discharge Assessment'];
  genderArray: number[]=[];
  subjectCount: number[]=[];
  sessionCountArray: number[]=[];
  SelectedCentre:any

  // Group Session graph data
  groupSessionData: any[] = [];
  groupSessionCountArray: number[] = [];
  groupSubjectCountArray: number[] = [];
  // Group session-specific labels (different from individual session labels)
  groupSessionTypeLables: string[] = ['Regular Study', 'Activity Session', 'Special Day'];
  groupSessionSubjectLables: string[] = ['Language', 'Math', 'EVS', 'Activity', 'NA'];

  // Show/Hide filters toggle
  showFilters: boolean = true;

  // Attendance (Present/Absent) graph data
  attendanceLabels: string[] = ['Present', 'Absent'];
  attendanceCountArray: number[] = [];
  mChildren!: FullChild[];
  selectedChild: any;
  selectedChildFirstName: any;
  selectedChildLastName: any;
  fileName = 'Analytical_Report.xlsx';

  constructor(private mCentreService: CentreService,
              private mFirestore: AngularFirestore,
              private mDatabase: AngularFireDatabase,
              private childService: ChildService,
              private educationService: EducationService,
              private readonly mSnackbar: MatSnackBar,
              private mLogService:LogService,
              private readonly financialYearService: FinancialYearService,
  ) {
    this.centres$ = this.mCentreService.getAllCentres();
    this.baseRef = this.mFirestore.collection<any>(`educationTest`);

    this.dataSource = new MatTableDataSource<any>()
    this.dataSource.paginator= this.paginator
  }

  ngOnInit(): void {
    // Only default to the current financial year in standalone mode — nested mode
    // (hideFilters=true) is fully driven by externalStartDate/externalEndDate via ngOnChanges.
    if (this.hideFilters) return;
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Normalise to a clean string[] of centre codes
    const normaliseCentres = (c: string | string[]): string[] => {
      const arr = Array.isArray(c) ? c : (c ? [c] : []);
      return arr.filter(code => code && code !== 'All' && code !== 'All Centres');
    };

    // Helper for legacy selectedCentre string
    const normalizeCentre = (c: string | string[]) => {
      const codes = normaliseCentres(c);
      return codes.length === 1 ? codes[0] : 'All';
    };

    // Sync external inputs from parent component (always, regardless of hideFilters)
    if (changes['externalStartDate'] && this.externalStartDate) {
      this.startDate = this.externalStartDate;
    }
    if (changes['externalEndDate'] && this.externalEndDate) {
      this.endDate = this.externalEndDate;
    }
    if (changes['externalCentre']) {
      this.selectedCentreCodes = normaliseCentres(this.externalCentre);
      this.selectedCentre = normalizeCentre(this.externalCentre);
    }

    // Trigger search when parent increments the counter
    if (changes['triggerSearch'] && changes['triggerSearch'].currentValue > 0) {
      if (this.externalStartDate && this.externalEndDate) {
        this.startDate = this.externalStartDate;
        this.endDate = this.externalEndDate;
        this.selectedCentreCodes = normaliseCentres(this.externalCentre);
        this.selectedCentre = normalizeCentre(this.externalCentre);
      }
      setTimeout(() => this.getData(), 100);
    }
  }

  getData() {
    // Clear table data
    this.ClearAll();

    // Validate if the start and end date are set
    if (!this.startDate || !this.endDate) {
      this.mSnackbar.open('Please select a proper date range first', '', {
        panelClass: 'error',
        duration: 3000
      });
      return;
    }

    // Query for the education data (with applied filters)
    const query = this.mFirestore.collection<any>('educationTest', (ref) => {

      const activity = {
        date: new Date().getTime(),
        section: 'Group Education',
        action: 'Filter',
        description: `Education Filter Analytical Report by user`,
        currentIp: localStorage.getItem('currentip')!
      };

      this.mLogService.addLog(activity)


      let queryRef: firebase.firestore.Query<any> = ref;

      // Apply filters if they are not set to 'All'
      if (this.selectedCentreCodes.length === 1) {
        // Single centre — use equality filter (index-friendly)
        queryRef = queryRef.where('centreCode', '==', this.selectedCentreCodes[0]);
      } else if (this.selectedCentreCodes.length > 1) {
        // Multiple centres — use 'in' filter (Firestore supports up to 10 values)
        queryRef = queryRef.where('centreCode', 'in', this.selectedCentreCodes.slice(0, 10));
      }
      // else: no filter → all centres
      if (this.startDate && this.endDate) {
        queryRef = queryRef.where('sessionDate', '>=', this.startDate).where('sessionDate', '<=', endOfDay(this.endDate));
      }
      if (this.selectedGender && this.selectedGender != 'All') {
        queryRef = queryRef.where('gender', '==', this.selectedGender);
      }
      if (this.sessionType && this.sessionType != 'All') {
        queryRef = queryRef.where('sessionType', '==', this.sessionType);
      }
      if (this.selectedSubject && this.selectedSubject != 'All') {
        queryRef = queryRef.where('subject', 'array-contains', this.selectedSubject);
      }
      if (this.selectedAttendace && this.selectedAttendace != 'All') {
        queryRef = queryRef.where('present', '==', this.selectedAttendace);
      }
      if (this.selectedChild && this.selectedChild != 'All') {
        queryRef = queryRef.where('childName', '==', this.selectedChild);
      }

      return queryRef;


    });

    // Subscribe to the data and update the graph
    query.valueChanges({ idField: 'id' }).pipe(takeUntil(this._destroyed$)).subscribe((data) => {
      this.educationData = data;

      // Initialize MatTableDataSource with education data
      this.dataSource = new MatTableDataSource(this.educationData);
      this.dataSource.paginator = this.paginator; // Attach paginator
      this.dataSource.sort = this.sort; // Attach sorting

      // Log data and calculate graph
      console.log(data);
      this.calculateGenderGraph(this.educationData); // Calculate and display graph
    });

    // Also fetch group session data for the same filters
    this.getGroupData();
  }

  /** Fetch group sessions from educationGroupTest and compute graph data */
  getGroupData() {
    if (!this.startDate || !this.endDate) return;

    this.mFirestore.collection<any>(this.env.educationGroup, (ref) => {
      let queryRef: firebase.firestore.Query<any> = ref;
      queryRef = queryRef
        .where('sessionDate', '>=', this.startDate)
        .where('sessionDate', '<=', endOfDay(this.endDate));
      return queryRef;
    }).valueChanges({ idField: 'id' }).pipe(takeUntil(this._destroyed$)).subscribe((data: any[]) => {
      // Client-side centre filter (centres is an array of {centreCode, centreName} objects)
      if (this.selectedCentreCodes.length > 0) {
        this.groupSessionData = data.filter(session => {
          const centres: any[] = session.centres || [];
          return centres.some(c => this.selectedCentreCodes.includes(c.centreCode));
        });
      } else {
        this.groupSessionData = data;
      }
      console.log('Group sessions:', this.groupSessionData.length);
      this.calculateGroupSessionGraph(this.groupSessionData);
    });
  }

  /** Calculate group session type & subject counts for graphs */
  private calculateGroupSessionGraph(data: any[]) {
    // Group session types: 'Regular Study', 'Activity Session', 'Special Day'
    // Note: stored value may have trailing space (e.g. "Regular Study "), so trim before compare
    this.groupSessionCountArray = this.groupSessionTypeLables.map(label =>
      data.filter((x: any) => (x.sessionType || '').trim() === label).length
    );
    // Group subjects: 'Language', 'Math', 'EVS', 'Activity', 'NA'
    // subject is stored as an array in group sessions
    this.groupSubjectCountArray = this.groupSessionSubjectLables.map(subj =>
      data.filter((x: any) => {
        const subjects: any[] = Array.isArray(x.subject) ? x.subject : (x.subject ? [x.subject] : []);
        return subjects.some((s: string) => (s || '').trim() === subj);
      }).length
    );
  }

  downloadExcel() {
    // Use filtered data if filter is applied, else full data
    const tableData = this.dataSource?.filteredData?.length
      ? this.dataSource.filteredData
      : this.dataSource.data;

    if (!tableData || tableData.length === 0) {
      this.mSnackbar.open('No data available to download', '', {
        duration: 3000,
        panelClass: 'error'
      });
      return;
    }

    // Prepare Excel rows
    const exportData = tableData.map((row: any, index: number) => ({
      'Sr No': index + 1,
      'Centre Name': row.centreName || '-',
      'Child Name': row.childName || '-',
      'Gender': row.gender || '-',
      'Session Type': row.sessionType || '-',
      'Subject': row.subject || '-',
      'Attendance': row.present === 'Present' ? 'P' : 'A',
      'Session Date': row.sessionDate?.toDate
        ? row.sessionDate.toDate().toLocaleDateString('en-GB')
        : '-'
    }));

    // Create worksheet & workbook
    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Education Report');

    // Download file
    XLSX.writeFile(workbook, this.fileName);
  }


  getPresent(element:any) {
    let st = 'A'
    if(element.present=="Present") st ='P'
    return st
  }

  Clear() {
    this.selectedGender=null
    this.selectedCentre =null
    this.selectedSubject=null
    this.sessionType=null
    this.selectedChild=null
    this.selectedAttendace=null
    const fy = this.financialYearService.getCurrentFinancialYear();
    this.startDate = fy.startDate;
    this.endDate = fy.endDate;
    this.educationData = []
    this.dataSource.data = []
    this.genderArray = []
    this.subjectCount = []
    this.sessionCountArray = []
    this.groupSessionData = []
    this.groupSessionCountArray = []
    this.groupSubjectCountArray = []
    this.attendanceCountArray = []
  }

  ClearAll() {
    this.educationData = []
    this.dataSource.data = []
    this.genderArray = []
    this.subjectCount = []
    this.sessionCountArray = []
    this.groupSessionData = []
    this.groupSessionCountArray = []
    this.groupSubjectCountArray = []
    this.attendanceCountArray = []
  }

  private calculateGenderGraph(educationData: any[]) {
    let totalMales = educationData.filter((x:any)=>x.gender=='Male').length
    let totalFeMales = educationData.filter((x:any)=>x.gender=='Female').length
    let totalLanguage = educationData.filter((x:any)=>x.subject=='Language').length
    let totalMaths = educationData.filter((x:any)=>x.subject=='Math').length
    let totalEVS = educationData.filter((x:any)=>x.subject=='EVS/GK').length

    this.genderArray = [totalMales,totalFeMales]
    this.subjectCount = [totalLanguage,totalMaths,totalEVS]

    // Attendance (Present/Absent) counts
    const totalPresent = educationData.filter((x: any) => x.present === 'Present').length;
    const totalAbsent = educationData.filter((x: any) => x.present === 'Absent' || x.present !== 'Present').length;
    this.attendanceCountArray = [totalPresent, totalAbsent];

    // this.sessionLables=[]
    this.sessionLables.forEach(it=>{
      this.sessionCountArray.push(educationData.filter((x:any)=>x.sessionType==it).length)
    })
  }

  // onChildSelect($event: MatSelectChange) {
  //   console.log($event.value.firstName)
  //   this.selectedChild = $event.value.firstName + ' ' + $event.value.lastName;
  //   console.log(this.selectedChild)
  // }


  onChildSelect($event: MatSelectChange) {
    if ($event.value === 'All') {
      this.selectedChild = null; // No filter applied → show all
    } else {
      this.selectedChild = $event.value.firstName + ' ' + $event.value.lastName;
    }
    console.log(this.selectedChild);
  }

  onCentreSelect($event: MatSelectChange) {
    this.SelectedCentre = $event.value
    this.childService.getAllotedChildListByCenter(this.SelectedCentre)
      .subscribe(res => this.mChildren = res)
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  toggleFilters() {
    this.showFilters = !this.showFilters;
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }
}
